<script setup lang="ts">
import type { TpgSelectEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';

export interface GrammarQuaternaryMenuButtonProps {
  activated?: boolean;
  label?: string;
  disabled?: boolean;
  iconTemplate?: IconConstant | '';
  iconPosition?: 'leading' | 'trailing' | 'top';
  size?: 'x-small' | 'small' | 'regular';
  isOpen?: boolean;
}

const props = withDefaults(defineProps<GrammarQuaternaryMenuButtonProps>(), {
  activated: false,
  label: '',
  disabled: false,
  iconTemplate: '',
  iconPosition: 'leading',
  size: 'regular',
  isOpen: false,
});

const emit = defineEmits(['select']);
function onSelect(event: TpgSelectEvent) {
  emit('select', event);
}
</script>

<template>
  <tpg-quaternary-menu-button v-bind="props" @tpg-select="onSelect">
    <slot />
  </tpg-quaternary-menu-button>
</template>
